export const AUTH_TOKEN = "promote2earn_dash_auth_token";
